import { render } from "./VPAAUploadedComplianceDialog.vue?vue&type=template&id=22a689fe&scoped=true"
import script from "./VPAAUploadedComplianceDialog.vue?vue&type=script&lang=js"
export * from "./VPAAUploadedComplianceDialog.vue?vue&type=script&lang=js"

import "./VPAAUploadedComplianceDialog.vue?vue&type=style&index=0&id=22a689fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a689fe"]])

export default __exports__